import { render, staticRenderFns } from "./CadastrarAtendenteUnidade.vue?vue&type=template&id=dac99af8"
import script from "./CadastrarAtendenteUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarAtendenteUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports